export default __webpack_public_path__ + "static/media/privacy_policy.a87cb48f.pdf";